import React from "react";
import { Result, Button } from "antd";
import { useTranslation } from "react-i18next";
import PageMeta from "../common/PageMeta";
import LocalizedLink from "../components/LocalizedLink";

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        padding: "80px 24px",
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <PageMeta
        title={t("not_found.page_title", "404 - ページが見つかりません | ウィソフト株式会社")}
        description={t(
          "not_found.description",
          "アクセスしようとしたページは、削除されたか、名前が変更された可能性があります。"
        )}
        noindex={true}
      />
      <Result
        status="404"
        title="404"
        subTitle={t("not_found.sub_title", "お探しのページは見つかりませんでした")}
        extra={
          <div style={{ maxWidth: 480, margin: "0 auto" }}>
            <p style={{ color: "#666", marginBottom: 24, fontSize: 15 }}>
              {t("not_found.description")}
            </p>
            <LocalizedLink to="/">
              <Button type="primary" size="large" style={{ minWidth: 160 }}>
                {t("not_found.back_home", "トップページへ戻る")}
              </Button>
            </LocalizedLink>
          </div>
        }
      />
    </div>
  );
};

export default NotFound;
